import {
  FontWeight, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css, keyframes } from 'styled-components';
import { AgentProfileBySalesColor } from './types';

const fadeInWithTranslation = keyframes`
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    filter: grayScale(100);
  }
  to {
    opacity: 1;
    filter: grayScale(0);
  }
`;

export const basic: ThemedFunctor = ({ theme, $color, $isSkeleton }) => css`
  background: ${theme.color.background[$color as AgentProfileBySalesColor].default.low};
  color: ${theme.color.foreground[$color as AgentProfileBySalesColor].default.low};
  padding: ${theme.remSize[150]};
  border-radius: ${theme.remRounding['2XS']};
  display: flex;
  gap: ${theme.remSize[200]};
  animation: ${$isSkeleton ? fadeInWithTranslation : fadeIn} .5s ease-in-out;
`;

export const icon: ThemedFunctor = ({ theme, $color }) => css`
  background: ${theme.color.background[$color as AgentProfileBySalesColor].hover.low};
  padding: ${theme.remSize[200]};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const info: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  padding: ${theme.remSize[50]} 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[150]};
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.HEADING_3, { fontWeight: FontWeight.MEDIUM })}
`;

export const description: ThemedFunctor = ({ theme, $color }) => css`
  ${getTypography(theme, TypographyName.BODY_SMALL, { fontWeight: FontWeight.LIGHT })}
  text-wrap: balance;
  color: ${theme.color.foreground[$color as AgentProfileBySalesColor].default.low};
`;
